import { lazy } from 'react';
export var ContactPageAsync = lazy(function () { return import('./ContactPage'); });
